import { render } from "./ConfirmEmail.vue?vue&type=template&id=d38aeefa&scoped=true"
import script from "./ConfirmEmail.vue?vue&type=script&lang=js"
export * from "./ConfirmEmail.vue?vue&type=script&lang=js"

import "./custom-confirm-email.scss?vue&type=style&index=0&id=d38aeefa&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d38aeefa"]])

export default __exports__